<template>
  <designer-orders v-if="is_designer"/>
  <admin-orders v-else/>
</template>
<script>
import AdminOrders from "./AdminOrders";
import DesignerOrders from "@/views/shop/designers/DesignerOrders";

export default {
  components: { AdminOrders, DesignerOrders },
  data() {
    return {
    };
  },
  computed: {
    is_designer() {
      return this.$acl.isDesigner
    }
  },
};
</script>
